<div class="prediction-table-wrap">
  <div *ngIf="isdtcListTable">
    <div class="table-header">{{tableHeader}}</div>
    <app-common-table [tableData]="dtcListData" [columnHeader]="columns" pageType="caseDtcPredictions"
      class="app-common-table" [actionPermission]="{pagination: true}" (tableAction)="tableAction($event)">
    </app-common-table>
  </div>
  <div *ngIf="!isdtcListTable">
    <div class="d-flex gap-10 ml-3 mb-2">
      <img alt="back" (click)="handleBack()" class="cursor" src="../../../../assets/images/arrow_circle_left.svg" />
      <div class="table-header-vehicle-list">DTC Prediction - Vehicle List</div>
      <!-- <div class="dtc-capsule"
        [ngClass]="{'dtc-capsule-green': selectedBrekdownRiskType === 'low', 'dtc-capsule-yellow': selectedBrekdownRiskType === 'medium', 'dtc-capsule-red': selectedBrekdownRiskType === 'high'}">
        {{ selectedBrekdownRiskType | titlecase }}
      </div> -->
    </div>
    <div class="dtc-info-row">
      <div class="dtc-box-dtc">
        <div class="dtcred-box">
          <div class="dtc-box-header">
            <div class="dtc-heading" id="dtc-placeholder">{{ selectedDTC }}</div>
          </div>
          <h4 class="dtc-box-subheader">{{ selectedDTCDescription }}</h4>
          <div class="dtc-box-description">
            Subsystem: Ignition System
          </div>
        </div>
      </div>

      <div class="dtc-box">
        <div class="d-flex gap-1">
          <div class="dtc-cont1-header mb-20">Parameter Thresholds</div>
          <img alt="Info" [matTooltip]="tooltipInfo" class="h-20" src="../../../../assets/images/info-icon.svg">
        </div>
        <div class="dtc-progress-container">
          <div>
            <div class="mb-1" *ngFor="let param of noramlParamRangeList?.slice(0, 3)">
              <div class="dtc-label-bar">
                <label class="dtc-progress-label dtc-bar-label">{{ param.label }}</label>
                <span class="dtc-progress-percent">{{ param.width }}</span>
              </div>
              <div class="dtc-progress-row">
                <div class="dtc-progress-bar ">
                  <div class="dtc-progress-fill" [style.width]="param.width"></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="mb-1" *ngFor="let param of noramlParamRangeList?.slice(3, 6)">
              <div class="dtc-label-bar">
                <label class="dtc-progress-label dtc-bar-label">{{ param.label }}</label>
                <span class="dtc-progress-percent">{{ param.width }}</span>
              </div>
              <div class="dtc-progress-row">
                <div class="dtc-progress-bar ">
                  <div class="dtc-progress-fill" [style.width]="param.width"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-common-table [tableData]="vehicleListTableData" [columnHeader]="vehicleListTableColumn"
      pageType="caseDtcPredictions" class="app-common-table" [actionPermission]="{pagination: true}"
      (tableAction)="tableAction($event)">
    </app-common-table>
  </div>
</div>